import { initPostHog, posthog } from "./posthog";

const POSTHOG_ENABLED = import.meta.env.VITE_POSTHOG_ENABLED === "true";

// Returns an initialized PostHog client, or null when analytics is disabled or
// unavailable. A PostHog failure must never break the payment flow, so every
// entry point below funnels through here and swallows its own errors.
function client() {
  if (!POSTHOG_ENABLED || typeof window === "undefined") return null;
  try {
    return initPostHog();
  } catch (error) {
    console.log("posthog init failed", error);
    return null;
  }
}

function safeCapture(event, properties) {
  const ph = client();
  if (!ph) return;
  try {
    ph.capture(event, properties);
  } catch (error) {
    console.log(`posthog capture failed (${event})`, error);
  }
}

// Each order is a distinct funnel participant identified as `order:<guid>`.
// If a different order was opened earlier in this browser, reset first so the
// two orders are never merged.
export function identifyOrder(guid) {
  const ph = client();
  if (!ph || !guid) return;
  try {
    const orderDistinctId = `order:${guid}`;
    if (ph.get_distinct_id() !== orderDistinctId) {
      ph.reset();
      ph.identify(orderDistinctId);
    }
  } catch (error) {
    console.log("posthog identify failed", error);
  }
}

export function capturePaymentPageLoaded(properties) {
  safeCapture("payment_page_loaded", properties);
}

export function capturePaymentMethodAttempted(properties) {
  safeCapture("payment_method_attempted", properties);
}

export function capturePaymentConfirmationSubmitted(properties) {
  safeCapture("payment_confirmation_submitted", properties);
}

export function capturePaymentStatusObserved(properties) {
  safeCapture("payment_status_observed", properties);
}
